<template>
    <div>
        <el-card class="content-card">
            <!-- Personal Details Section -->
            <div class="section personal-details">
                <div class="section-header">
                    <h3>Personal Details</h3>
                    <a class="edit-link" href="javascript:void(0)" @click="openEditr">Edit</a>
                </div>
                <el-divider></el-divider>
                <div class="section-body">
                    <p><strong>Name:</strong> {{ userData.first_name }}</p>
                    <el-divider></el-divider>
                    <p><strong>Email Address:</strong> {{ userData.email }}</p>
                    <el-divider></el-divider>
                    <p><strong>Time Zone:</strong> {{ userData.timezone || 'Not yet' }}</p>
                    <el-divider></el-divider>
                    <p><strong>Phone Number:</strong> {{ userData.phone || 'Not yet' }}</p>
                    <el-divider></el-divider>
                    <p><strong>Birthday Time:</strong> {{ userData.date_of_birth || 'Not yet' }}</p>
                </div>
            </div>
            <!-- Community Profile Section -->
            <!-- <div class="section community-profile">
                <div class="section-footer">
                    <a class="link" href="javascript:void(0)">Start your community profile</a>
                </div>
            </div> -->
        </el-card>

        <!-- Drawer Component -->
        <el-drawer title="Edit Personal Details" :visible.sync="drawerVisible" size="50%" custom-class="drawer">
            <div class="profile-update-page">
                <!-- Header -->
                <div class="header">
                    <h2>Update Your Profile</h2>
                    <div class="actions">
                        <el-button size="small">Discard Changes</el-button>
                        <el-button type="primary" size="small" disabled>Update Profile</el-button>
                    </div>
                </div>

                <div class="content">
                    <!-- Left Panel -->
                    <div class="left-panel">
                        <h3>Personal Details</h3>
                        <p>You can update the details we have on file for you.</p>
                    </div>

                    <!-- Right Panel Form -->
                    <el-card class="form-card">
                        <el-form :model="form" label-width="150px">
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item label="First Name">
                                        <el-input v-model="form.firstName"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="Last Name">
                                        <el-input v-model="form.lastName"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-form-item label="Email Address">
                                <el-input v-model="form.email" disabled></el-input>
                            </el-form-item>

                            <el-form-item label="Verified Phone Number">
                                <el-input v-model="form.phoneNumber" disabled placeholder="No verified phone number">
                                    <template #prepend>
                                        <el-select v-model="form.countryCode" placeholder="Select">
                                            <el-option label="US" value="US"></el-option>
                                            <el-option label="CN" value="CN"></el-option>
                                        </el-select>
                                    </template>
                                </el-input>
                            </el-form-item>

                            <!-- <el-form-item label="Default Address">
                                <p class="link"><a href="javascript:void(0)">Add a new address</a></p>
                            </el-form-item> -->

                            <!-- <el-form-item label="Billing Payment Methods">
                                <p class="link"><a href="javascript:void(0)">Add a new payment method</a></p>
                            </el-form-item> -->

                            <el-form-item label="Avatar" style="line-height: normal;">
                                <div class="avatar">
                                    <div class="avatar-circle">CR</div>
                                    <p>
                                        Select an image to upload or customize via
                                        <a href="https://gravatar.com" target="_blank">Gravatar.com</a>
                                    </p>
                                </div>
                            </el-form-item>
                        </el-form>
                    </el-card>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    name: "ProfileDetails",
    data() {
        return {
            drawerVisible: false,
            form: {
                first_name: "Cha",
                lastName: "Ron",
                email: "czp2250@outlook.com",
                phoneNumber: "",
                countryCode: "US"
            }
        };
    },
    computed: {
        ...mapGetters("user", ["userData"]),
    },
    // created() {
    //     this.userDataApi()
    // },
    // mounted() {
    //     this.userDataApi()
    // },
    methods: {
        // async userDataApi() {
        //     const res = await userData()
        //     console.log(res);
        //     if (res.success) {
        //         this.form = res.body
        //     }
        // },
        openEditr() {
            this.$router.push('/user/edit')
        },
    }
};
</script>

<style scoped>
/* General Styles */
.content-card {
    padding: 20px;
    border-radius: 8px;
    background-color: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Section Styles */
.section {
    margin-bottom: 20px;
}

.section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    font-weight: bold;
    color: #333;
}

.section-body p {
    margin: 10px 0;
    font-size: 14px;
    color: #333;
}

.section-footer {
    text-align: right;
    font-size: 14px;
}

/* Links */
.link {
    color: #007bff;
    text-decoration: none;
}

.link:hover {
    text-decoration: underline;
}

.edit-link {
    font-size: 14px;
    color: #007bff;
    cursor: pointer;
}

.edit-link:hover {
    text-decoration: underline;
}

/* Drawer Styles */
.profile-update-page {
    padding: 20px;
    background-color: #f6f6f6;
    font-family: Arial, sans-serif;
}

/* Header */
.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.header h2 {
    font-size: 20px;
    font-weight: bold;
    margin: 0;
    color: #333;
}

/* Content Layout */
.content {
    display: flex;
    gap: 20px;
}

/* Left Panel */
.left-panel {
    flex: 1;
    max-width: 200px;
}

.left-panel h3 {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
    color: #333;
}

.left-panel p {
    font-size: 14px;
    color: #666;
}

/* Right Panel - Form Card */
.form-card {
    flex: 3;
    padding: 20px;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Avatar */
.avatar {
    display: flex;
    align-items: center;
    gap: 10px;
}

.avatar-circle {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: #f56c6c;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    font-weight: bold;
}
</style>